<template>
  <div class="flex flex-col items-center">
    <svg v-if="available" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="15" fill="#FFEEF8" stroke="#99005C" stroke-width="2" />
      <g clip-path="url(#clip0_2889_3280)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 13.3333C14.5272 13.3333 13.3333 14.5272 13.3333 16C13.3333 17.4728 14.5272 18.6667 16 18.6667C17.4728 18.6667 18.6667 17.4728 18.6667 16C18.6667 14.5272 17.4728 13.3333 16 13.3333ZM12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 18.2091 18.2091 20 16 20C13.7909 20 12 18.2091 12 16Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 8C16.3682 8 16.6667 8.29848 16.6667 8.66667V10C16.6667 10.3682 16.3682 10.6667 16 10.6667C15.6318 10.6667 15.3333 10.3682 15.3333 10V8.66667C15.3333 8.29848 15.6318 8 16 8Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 21.3333C16.3682 21.3333 16.6667 21.6318 16.6667 22V23.3333C16.6667 23.7015 16.3682 24 16 24C15.6318 24 15.3333 23.7015 15.3333 23.3333V22C15.3333 21.6318 15.6318 21.3333 16 21.3333Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3419 10.3419C10.6023 10.0816 11.0244 10.0816 11.2847 10.3419L12.2314 11.2886C12.4918 11.5489 12.4918 11.9711 12.2314 12.2314C11.9711 12.4918 11.5489 12.4918 11.2886 12.2314L10.3419 11.2847C10.0816 11.0244 10.0816 10.6023 10.3419 10.3419Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.7686 19.7686C20.0289 19.5082 20.4511 19.5082 20.7114 19.7686L21.6581 20.7153C21.9184 20.9756 21.9184 21.3977 21.6581 21.6581C21.3977 21.9184 20.9756 21.9184 20.7153 21.6581L19.7686 20.7114C19.5082 20.4511 19.5082 20.0289 19.7686 19.7686Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 16C8 15.6318 8.29848 15.3333 8.66667 15.3333H10C10.3682 15.3333 10.6667 15.6318 10.6667 16C10.6667 16.3682 10.3682 16.6667 10 16.6667H8.66667C8.29848 16.6667 8 16.3682 8 16Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3333 16C21.3333 15.6318 21.6318 15.3333 22 15.3333H23.3333C23.7015 15.3333 24 15.6318 24 16C24 16.3682 23.7015 16.6667 23.3333 16.6667H22C21.6318 16.6667 21.3333 16.3682 21.3333 16Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.2314 19.7686C12.4918 20.0289 12.4918 20.4511 12.2314 20.7114L11.2847 21.6581C11.0244 21.9184 10.6023 21.9184 10.3419 21.6581C10.0816 21.3977 10.0816 20.9756 10.3419 20.7153L11.2886 19.7686C11.5489 19.5082 11.9711 19.5082 12.2314 19.7686Z"
          fill="#99005C"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.6581 10.3419C21.9184 10.6023 21.9184 11.0244 21.6581 11.2847L20.7114 12.2314C20.4511 12.4918 20.0289 12.4918 19.7686 12.2314C19.5082 11.9711 19.5082 11.5489 19.7686 11.2886L20.7153 10.3419C20.9756 10.0816 21.3977 10.0816 21.6581 10.3419Z"
          fill="#99005C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2889_3280">
          <rect width="16" height="16" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="15.5" stroke="#6E6F74" />
      <g clip-path="url(#clip0_2889_3274)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 13.3333C14.5272 13.3333 13.3333 14.5272 13.3333 16C13.3333 17.4728 14.5272 18.6667 16 18.6667C17.4728 18.6667 18.6667 17.4728 18.6667 16C18.6667 14.5272 17.4728 13.3333 16 13.3333ZM12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 18.2091 18.2091 20 16 20C13.7909 20 12 18.2091 12 16Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 8C16.3682 8 16.6667 8.29848 16.6667 8.66667V10C16.6667 10.3682 16.3682 10.6667 16 10.6667C15.6318 10.6667 15.3333 10.3682 15.3333 10V8.66667C15.3333 8.29848 15.6318 8 16 8Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 21.3333C16.3682 21.3333 16.6667 21.6318 16.6667 22V23.3333C16.6667 23.7015 16.3682 24 16 24C15.6318 24 15.3333 23.7015 15.3333 23.3333V22C15.3333 21.6318 15.6318 21.3333 16 21.3333Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3419 10.3419C10.6023 10.0816 11.0244 10.0816 11.2847 10.3419L12.2314 11.2886C12.4918 11.5489 12.4918 11.9711 12.2314 12.2314C11.9711 12.4918 11.5489 12.4918 11.2886 12.2314L10.3419 11.2847C10.0816 11.0244 10.0816 10.6023 10.3419 10.3419Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.7686 19.7686C20.0289 19.5082 20.4511 19.5082 20.7114 19.7686L21.6581 20.7153C21.9184 20.9756 21.9184 21.3977 21.6581 21.6581C21.3977 21.9184 20.9756 21.9184 20.7153 21.6581L19.7686 20.7114C19.5082 20.4511 19.5082 20.0289 19.7686 19.7686Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 16C8 15.6318 8.29848 15.3333 8.66667 15.3333H10C10.3682 15.3333 10.6667 15.6318 10.6667 16C10.6667 16.3682 10.3682 16.6667 10 16.6667H8.66667C8.29848 16.6667 8 16.3682 8 16Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3333 16C21.3333 15.6318 21.6318 15.3333 22 15.3333H23.3333C23.7015 15.3333 24 15.6318 24 16C24 16.3682 23.7015 16.6667 23.3333 16.6667H22C21.6318 16.6667 21.3333 16.3682 21.3333 16Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.2314 19.7686C12.4918 20.0289 12.4918 20.4511 12.2314 20.7114L11.2847 21.6581C11.0244 21.9184 10.6023 21.9184 10.3419 21.6581C10.0816 21.3977 10.0816 20.9756 10.3419 20.7153L11.2886 19.7686C11.5489 19.5082 11.9711 19.5082 12.2314 19.7686Z"
          fill="#6E6F74"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.6581 10.3419C21.9184 10.6023 21.9184 11.0244 21.6581 11.2847L20.7114 12.2314C20.4511 12.4918 20.0289 12.4918 19.7686 12.2314C19.5082 11.9711 19.5082 11.5489 19.7686 11.2886L20.7153 10.3419C20.9756 10.0816 21.3977 10.0816 21.6581 10.3419Z"
          fill="#6E6F74"
        />
      </g>
    </svg>
    <div v-if="available">
      <span class="text-caption text-primary">Afternoon</span>
      <span class="sr-only">Available</span>
    </div>
    <div v-else>
      <span class="text-caption text-grey-text-subdued">Afternoon</span>
      <span class="sr-only">Unavailable</span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Afternoon',
  props: {
    available: { type: Boolean, default: false },
  },
};
</script>
